<template>
    <confirm-modal @confirm="remove" ref="modal">
        <div class="font-weight:700">刪除話題</div>
        <div class="f:20 font-weight:normal mt:24 color:gray02">刪除後話題將不保留，確定刪除嗎？</div>
    </confirm-modal>
</template>

<script setup>
    const modal = ref();

    let topic_id;

    const emit = defineEmits(["remove"]);

    const remove = () => {
        api("api/topic/remove", { topic_id }).done((res) => {
            if (res.success) {
                emit("remove");
            }
        });
    };

    const show = (id) => {
        topic_id = id;

        modal.value.show();
    };

    defineExpose({ show });
</script>
